export default __webpack_public_path__ + "static/media/icn-brakejaws.6777c80c.svg";